import React from "react";
import { FULLY_SET_BOOLEAN_ENDPOINT } from "../../functions/mdmCommandUtils";
import CommandModalActions from "./CommandModalActions";

const MdmCommandModal = ({
  isOpen,
  onClose,
  commandScope,
  activeCommandOptions,
  commandEndpoint,
  setCommandEndpoint,
  isSendingCommand,
  isFieldTriggerConfigUpdateCommand,
  isFieldTriggerDatabaseUpdateCommand,
  isFieldChangeNcrServerCommand,
  isFieldFetchNcrStatusCommand,
  isFullySettingsCommand,
  fullySettingsGroupKey,
  k10GroupKey,
  visibleK10Options = [],
  visibleFullySettingsOptions,
  fullySettingKey,
  setFullySettingKey,
  fullySettingValue,
  setFullySettingValue,
  fullySettingBooleanValue,
  setFullySettingBooleanValue,
  isLoadApkFileCommand,
  loadApkUrl,
  setLoadApkUrl,
  fieldDatabaseUpdateCommandKey,
  fieldDatabaseUpdateOptions,
  fieldNcrServerOptions = [],
  selectedNcrServerTarget,
  setSelectedNcrServerTarget,
  selectedFieldConfigCategory,
  setSelectedFieldConfigCategory,
  fieldConfigCategoryOptions,
  isFetchingFieldConfig,
  selectedFieldConfigValue,
  setSelectedFieldConfigValue,
  selectedFieldConfigValues,
  fieldConfigError,
  isFieldTriggerMicromomentCommand,
  currentBranchRetailerId,
  currentBranchStoreId,
  selectedMicromomentId,
  setSelectedMicromomentId,
  micromomentOptions,
  isFetchingMicromoments,
  micromomentError,
  fieldCommandResponse,
  isFieldScanAndGoReleaseWallCommand,
  isFieldScanAndGoAllowedReleaseCommand,
  isFieldMultiSwanSongCommand,
  isFieldTriggerCameraCommand,
  isFieldTriggerScreenshotCommand,
  isFieldMultiFetchLocationLogCommand,
  locationVersionFetchedDeviceIds = [],
  onShowLocationVersionWindow,
  triggeredSwanSongDeviceIds = [],
  onShowSwanSongResults,
  triggeredCameraDevices = [],
  onShowCameraResults,
  triggeredScreenshotDevices = [],
  allowedReleaseForScanAndGo,
  setAllowedReleaseForScanAndGo,
  allowedReleaseNotes,
  setAllowedReleaseNotes,
  isAllowedReleaseNotesRequired,
  isExecuteDisabled = false,
  isK10CsdkToggleCommand = false,
  isK10CsdkScheduleCommand = false,
  isK10ShutdownCommand = false,
  isK10Command = false,
  k10CsdkEnabled = true,
  setK10CsdkEnabled,
  k10CsdkOnStartAppEnabled = true,
  setK10CsdkOnStartAppEnabled,
  k10CsdkScheduleHour = 0,
  setK10CsdkScheduleHour,
  k10CsdkScheduleMinute = 0,
  setK10CsdkScheduleMinute,
  k10CsdkScheduleEnabled = true,
  setK10CsdkScheduleEnabled,
  nonK10SelectedDevices = [],
  k10LenovoDeviceModel = "Lenovo TB-X6C6X",
  scanAndGoWallOptions,
  selectedScanAndGoWallIds,
  toggleScanAndGoWallSelection,
  commandBroadcastTargetLabel,
  getTextPayloadKeyForEndpoint,
  textCommandOptions,
  commandMessageText,
  setCommandMessageText,
  parsedPayloadDeviceCount,
  commandTargetDevices = [],
  progressDone,
  progressTotal,
  progressPercent,
  commandProgress,
  commandUpdatedDevices,
  commandSuccessfulDeviceIds,
  showSuccessfulDeviceIds,
  setShowSuccessfulDeviceIds,
  commandFailedDeviceIds,
  showFailedDeviceIds,
  setShowFailedDeviceIds,
  commandError,
  onExecute,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-on-surface/40 backdrop-blur-sm" onClick={onClose}></div>
      <div className="relative bg-surface-container-lowest w-full max-w-lg max-h-[90vh] rounded-2xl shadow-2xl overflow-hidden flex flex-col">
        <div className="p-6 border-b border-outline-variant/10 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-primary-fixed rounded-lg text-primary">
              <span className="material-symbols-outlined">terminal</span>
            </div>
            <div>
              <h2 className="font-headline font-bold text-lg">
                {commandScope === "field" ? "Queue Field Command" : "Queue Device Command"}
              </h2>
              <p className="text-xs text-on-surface-variant">
                {commandScope === "field"
                  ? "Broadcast field command to selected devices"
                  : "Broadcast command to selected devices"}
              </p>
            </div>
          </div>
          <button
            className="p-2 hover:bg-surface-container-low rounded-full transition-colors text-on-surface-variant"
            onClick={onClose}
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>
        <div className="p-6 space-y-4 overflow-y-auto flex-1">
          <div className="bg-surface-container-low p-4 rounded-xl space-y-2">
            <p className="text-xs font-semibold text-on-surface">Command</p>
            <div className="grid grid-cols-2 gap-2">
              {activeCommandOptions.map((option) => {
                const isActive =
                  commandEndpoint === option.value ||
                  (option.value === fieldDatabaseUpdateCommandKey &&
                    isFieldTriggerDatabaseUpdateCommand) ||
                  (option.value === fullySettingsGroupKey && isFullySettingsCommand) ||
                  (option.value === k10GroupKey && isK10Command);
                return (
                  <button
                    key={option.value}
                    type="button"
                    className={
                      isActive
                        ? "px-3 py-2 rounded-lg bg-primary text-white font-semibold text-xs"
                        : "px-3 py-2 rounded-lg bg-surface-container-high text-on-surface font-semibold text-xs hover:bg-surface-container-highest transition-colors"
                    }
                    onClick={() => setCommandEndpoint(option.value)}
                    disabled={isSendingCommand}
                  >
                    {option.label}
                  </button>
                );
              })}
            </div>
          </div>
          {isLoadApkFileCommand && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-2">
              <label className="text-xs font-semibold text-on-surface" htmlFor="load-apk-url">
                URL
              </label>
              <input
                id="load-apk-url"
                type="text"
                className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                placeholder="https://example.com/app.apk"
                value={loadApkUrl}
                onChange={(e) => setLoadApkUrl(e.target.value)}
                disabled={isSendingCommand}
              />
              <p className="text-[11px] text-on-surface-variant">
                APK download URL sent to each selected device.
              </p>
            </div>
          )}
          {isK10Command && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
              <div className="space-y-1">
                <p className="text-xs font-semibold text-on-surface">K10 Commands</p>
                <p className="text-[11px] text-on-surface-variant">
                  Choose a K10 action for the selected Lenovo TB-X6C6X devices.
                </p>
              </div>
              <div className="space-y-2">
                <label className="text-xs font-semibold text-on-surface" htmlFor="k10-command-type">
                  Command
                </label>
                <select
                  id="k10-command-type"
                  className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                  value={commandEndpoint}
                  onChange={(e) => setCommandEndpoint(e.target.value)}
                  disabled={isSendingCommand || visibleK10Options.length === 0}
                >
                  {visibleK10Options.length === 0 && (
                    <option value="">No K10 commands available</option>
                  )}
                  {visibleK10Options.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              {isK10CsdkToggleCommand && (
                <div className="space-y-3 pt-1 border-t border-outline-variant/10">
                  <div className="space-y-2">
                    <label className="text-xs font-semibold text-on-surface" htmlFor="k10-csdk-enabled">
                      enabled
                    </label>
                    <select
                      id="k10-csdk-enabled"
                      className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                      value={k10CsdkEnabled ? "true" : "false"}
                      onChange={(e) => setK10CsdkEnabled(e.target.value === "true")}
                      disabled={isSendingCommand}
                    >
                      <option value="true">On</option>
                      <option value="false">Off</option>
                    </select>
                  </div>
                  <div className="space-y-2">
                    <label
                      className="text-xs font-semibold text-on-surface"
                      htmlFor="k10-csdk-on-start-app-enabled"
                    >
                      onStartAppEnabled
                    </label>
                    <select
                      id="k10-csdk-on-start-app-enabled"
                      className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                      value={k10CsdkOnStartAppEnabled ? "true" : "false"}
                      onChange={(e) => setK10CsdkOnStartAppEnabled(e.target.value === "true")}
                      disabled={isSendingCommand}
                    >
                      <option value="true">On</option>
                      <option value="false">Off</option>
                    </select>
                  </div>
                  <p className="text-[11px] text-on-surface-variant">
                    Both toggles are sent on every call as <span className="font-mono">B.enabled</span> and{" "}
                    <span className="font-mono">B.onStartAppEnabled</span>.
                  </p>
                </div>
              )}
              {isK10CsdkScheduleCommand && (
                <div className="space-y-3 pt-1 border-t border-outline-variant/10">
                  <div className="grid grid-cols-2 gap-3">
                    <div className="space-y-2">
                      <label className="text-xs font-semibold text-on-surface" htmlFor="k10-csdk-schedule-hour">
                        hour
                      </label>
                      <select
                        id="k10-csdk-schedule-hour"
                        className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                        value={k10CsdkScheduleHour}
                        onChange={(e) => setK10CsdkScheduleHour(Number(e.target.value))}
                        disabled={isSendingCommand}
                      >
                        {Array.from({ length: 24 }, (_, hour) => (
                          <option key={hour} value={hour}>
                            {hour}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="space-y-2">
                      <label className="text-xs font-semibold text-on-surface" htmlFor="k10-csdk-schedule-minute">
                        minute
                      </label>
                      <select
                        id="k10-csdk-schedule-minute"
                        className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                        value={k10CsdkScheduleMinute}
                        onChange={(e) => setK10CsdkScheduleMinute(Number(e.target.value))}
                        disabled={isSendingCommand}
                      >
                        {Array.from({ length: 60 }, (_, minute) => (
                          <option key={minute} value={minute}>
                            {minute}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <label className="text-xs font-semibold text-on-surface" htmlFor="k10-csdk-schedule-enabled">
                      enabled
                    </label>
                    <select
                      id="k10-csdk-schedule-enabled"
                      className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                      value={k10CsdkScheduleEnabled ? "true" : "false"}
                      onChange={(e) => setK10CsdkScheduleEnabled(e.target.value === "true")}
                      disabled={isSendingCommand}
                    >
                      <option value="true">On</option>
                      <option value="false">Off</option>
                    </select>
                  </div>
                  <div className="space-y-2">
                    <label
                      className="text-xs font-semibold text-on-surface"
                      htmlFor="k10-csdk-schedule-on-start-app-enabled"
                    >
                      onStartAppEnabled
                    </label>
                    <select
                      id="k10-csdk-schedule-on-start-app-enabled"
                      className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                      value={k10CsdkOnStartAppEnabled ? "true" : "false"}
                      onChange={(e) => setK10CsdkOnStartAppEnabled(e.target.value === "true")}
                      disabled={isSendingCommand}
                    >
                      <option value="true">On</option>
                      <option value="false">Off</option>
                    </select>
                  </div>
                  <p className="text-[11px] text-on-surface-variant">
                    Sent as <span className="font-mono">i.hour</span>, <span className="font-mono">i.minute</span>,{" "}
                    <span className="font-mono">B.enabled</span>, and{" "}
                    <span className="font-mono">B.onStartAppEnabled</span> on every call.
                  </p>
                </div>
              )}
              {isK10ShutdownCommand && (
                <p className="text-[11px] text-on-surface-variant pt-1 border-t border-outline-variant/10">
                  Sends the K10 shutdown intent immediately with no additional parameters.
                </p>
              )}
              {nonK10SelectedDevices.length > 0 && (
                <div className="bg-error-container/30 border border-error/20 p-3 rounded-lg space-y-2">
                  <p className="text-xs font-semibold text-error">
                    Only {k10LenovoDeviceModel} devices are supported for this command.
                  </p>
                  <ul className="max-h-32 overflow-y-auto text-[11px] text-on-surface-variant space-y-1">
                    {nonK10SelectedDevices.map((device) => (
                      <li key={device.deviceId} className="font-mono break-all">
                        {device.deviceId}
                        {device.model ? ` (${device.model})` : " (model unknown)"}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
          {isFullySettingsCommand && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
              <div className="space-y-1">
                <p className="text-xs font-semibold text-on-surface">Fully Settings</p>
                <p className="text-[11px] text-on-surface-variant">
                  Choose setting type and provide key/value for selected devices.
                </p>
              </div>
              <div className="space-y-2">
                <label className="text-xs font-semibold text-on-surface" htmlFor="fully-settings-type">
                  Setting Type
                </label>
                <select
                  id="fully-settings-type"
                  className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                  value={commandEndpoint}
                  onChange={(e) => setCommandEndpoint(e.target.value)}
                  disabled={isSendingCommand || visibleFullySettingsOptions.length === 0}
                >
                  {visibleFullySettingsOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="space-y-2">
                <label className="text-xs font-semibold text-on-surface" htmlFor="fully-setting-key">
                  Key
                </label>
                <input
                  id="fully-setting-key"
                  type="text"
                  className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                  placeholder="Setting key"
                  value={fullySettingKey}
                  onChange={(e) => setFullySettingKey(e.target.value)}
                  disabled={isSendingCommand}
                />
              </div>
              <div className="space-y-2">
                <label className="text-xs font-semibold text-on-surface" htmlFor="fully-setting-value">
                  Value
                </label>
                {commandEndpoint === FULLY_SET_BOOLEAN_ENDPOINT ? (
                  <select
                    id="fully-setting-value"
                    className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                    value={fullySettingBooleanValue ? "true" : "false"}
                    onChange={(e) => setFullySettingBooleanValue(e.target.value === "true")}
                    disabled={isSendingCommand}
                  >
                    <option value="true">True</option>
                    <option value="false">False</option>
                  </select>
                ) : (
                  <input
                    id="fully-setting-value"
                    type="text"
                    className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                    placeholder="Setting value"
                    value={fullySettingValue}
                    onChange={(e) => setFullySettingValue(e.target.value)}
                    disabled={isSendingCommand}
                  />
                )}
              </div>
            </div>
          )}
          {isFieldTriggerConfigUpdateCommand && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
              <div className="space-y-1">
                <p className="text-xs font-semibold text-on-surface">Config Update</p>
                <p className="text-[11px] text-on-surface-variant">
                  Choose config category and value from Field config service.
                </p>
              </div>
              <div className="space-y-2">
                <label className="text-xs font-semibold text-on-surface" htmlFor="field-config-category">
                  Config Category
                </label>
                <select
                  id="field-config-category"
                  className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                  value={selectedFieldConfigCategory}
                  onChange={(e) => setSelectedFieldConfigCategory(e.target.value)}
                  disabled={isSendingCommand || isFetchingFieldConfig}
                >
                  {fieldConfigCategoryOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="space-y-2">
                <label className="text-xs font-semibold text-on-surface" htmlFor="field-config-value">
                  Config Value
                </label>
                <select
                  id="field-config-value"
                  className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                  value={selectedFieldConfigValue}
                  onChange={(e) => setSelectedFieldConfigValue(e.target.value)}
                  disabled={
                    isSendingCommand || isFetchingFieldConfig || selectedFieldConfigValues.length === 0
                  }
                >
                  {selectedFieldConfigValues.length === 0 && (
                    <option value="">{isFetchingFieldConfig ? "Loading values..." : "No values found"}</option>
                  )}
                  {selectedFieldConfigValues.map((configValue) => (
                    <option key={configValue} value={configValue}>
                      {configValue}
                    </option>
                  ))}
                </select>
              </div>
              {fieldConfigError && <p className="text-xs text-error">{fieldConfigError}</p>}
            </div>
          )}
          {isFieldTriggerDatabaseUpdateCommand && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
              <div className="space-y-1">
                <p className="text-xs font-semibold text-on-surface">Database Update</p>
                <p className="text-[11px] text-on-surface-variant">
                  Choose update type for selected branch devices.
                </p>
              </div>
              <p className="text-[11px] text-on-surface-variant">
                retailer_id: {Number.isFinite(currentBranchRetailerId) ? currentBranchRetailerId : "-"} |
                branch_id: {Number.isFinite(currentBranchStoreId) ? currentBranchStoreId : "-"}
              </p>
              <div className="space-y-2">
                <label className="text-xs font-semibold text-on-surface" htmlFor="field-database-update-type">
                  Update Type
                </label>
                <select
                  id="field-database-update-type"
                  className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                  value={commandEndpoint}
                  onChange={(e) => setCommandEndpoint(e.target.value)}
                  disabled={isSendingCommand}
                >
                  {fieldDatabaseUpdateOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          {isFieldChangeNcrServerCommand && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
              <div className="space-y-1">
                <p className="text-xs font-semibold text-on-surface">Change NCR Server</p>
                <p className="text-[11px] text-on-surface-variant">
                  Switch selected branch devices between Store (Main) and Backup servers.
                </p>
              </div>
              <p className="text-[11px] text-on-surface-variant">
                retailer_id: {Number.isFinite(currentBranchRetailerId) ? currentBranchRetailerId : "-"} |
                branch_id: {Number.isFinite(currentBranchStoreId) ? currentBranchStoreId : "-"}
              </p>
              <div className="space-y-2">
                <label className="text-xs font-semibold text-on-surface" htmlFor="field-ncr-server-target">
                  Server Target
                </label>
                <select
                  id="field-ncr-server-target"
                  className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                  value={selectedNcrServerTarget}
                  onChange={(e) => setSelectedNcrServerTarget(e.target.value)}
                  disabled={isSendingCommand}
                >
                  {fieldNcrServerOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              {parsedPayloadDeviceCount === 0 && (
                <p className="text-xs text-error">Select at least one device before executing.</p>
              )}
            </div>
          )}
          {isFieldFetchNcrStatusCommand && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
              <div className="space-y-1">
                <p className="text-xs font-semibold text-on-surface">Fetch NCR Status</p>
                <p className="text-[11px] text-on-surface-variant">
                  Read the latest SNG_SERVER_FALLBACK_STATUS for selected branch devices.
                </p>
              </div>
              <p className="text-[11px] text-on-surface-variant">
                retailer_id: {Number.isFinite(currentBranchRetailerId) ? currentBranchRetailerId : "-"} |
                branch_id: {Number.isFinite(currentBranchStoreId) ? currentBranchStoreId : "-"}
              </p>
              {parsedPayloadDeviceCount === 0 && (
                <p className="text-xs text-error">Select at least one device before executing.</p>
              )}
            </div>
          )}
          {isFieldMultiFetchLocationLogCommand && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
              <div className="space-y-1">
                <p className="text-xs font-semibold text-on-surface">Get Location/Version</p>
                <p className="text-[11px] text-on-surface-variant">
                  Fetch location log data for the selected branch devices.
                </p>
              </div>
              <p className="text-[11px] text-on-surface-variant">
                retailer_id: {Number.isFinite(currentBranchRetailerId) ? currentBranchRetailerId : "-"} |
                branch_id: {Number.isFinite(currentBranchStoreId) ? currentBranchStoreId : "-"}
              </p>
              {parsedPayloadDeviceCount === 0 && (
                <p className="text-xs text-error">Select at least one device before executing.</p>
              )}
            </div>
          )}
          {isFieldTriggerMicromomentCommand && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
              <div className="space-y-1">
                <p className="text-xs font-semibold text-on-surface">Micromoment Trigger</p>
                <p className="text-[11px] text-on-surface-variant">
                  Choose a micromoment to trigger for selected branch devices.
                </p>
              </div>
              <p className="text-[11px] text-on-surface-variant">
                retailer: {Number.isFinite(currentBranchRetailerId) ? currentBranchRetailerId : "-"} |
                store: {Number.isFinite(currentBranchStoreId) ? currentBranchStoreId : "-"}
              </p>
              <div className="space-y-2">
                <label className="text-xs font-semibold text-on-surface" htmlFor="field-micromoment-value">
                  Micromoment
                </label>
                <select
                  id="field-micromoment-value"
                  className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                  value={selectedMicromomentId}
                  onChange={(e) => setSelectedMicromomentId(e.target.value)}
                  disabled={isSendingCommand || isFetchingMicromoments || micromomentOptions.length === 0}
                >
                  {micromomentOptions.length === 0 && (
                    <option value="">
                      {isFetchingMicromoments ? "Loading micromoments..." : "No micromoments found"}
                    </option>
                  )}
                  {micromomentOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              {micromomentError && <p className="text-xs text-error">{micromomentError}</p>}
            </div>
          )}
          {isFieldScanAndGoAllowedReleaseCommand && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
              <div className="space-y-2">
                <label className="text-xs font-semibold text-on-surface" htmlFor="field-scan-go-allowed">
                  Allowed
                </label>
                <select
                  id="field-scan-go-allowed"
                  className="w-full px-3 py-2 bg-surface-container-high text-on-surface font-semibold text-sm rounded-lg border-none outline-none focus:ring-2 focus:ring-primary/20"
                  value={allowedReleaseForScanAndGo ? "true" : "false"}
                  onChange={(e) => setAllowedReleaseForScanAndGo(e.target.value === "true")}
                  disabled={isSendingCommand}
                >
                  <option value="true">True</option>
                  <option value="false">False</option>
                </select>
                <p className="text-[11px] text-on-surface-variant">
                  Sent as <span className="font-mono">allowed</span> in the JSON payload with the selected device IDs.
                </p>
              </div>
              <div className="space-y-2">
                <label className="text-xs font-semibold text-on-surface" htmlFor="field-scan-go-allowed-notes">
                  Notes{isAllowedReleaseNotesRequired ? " *" : ""}
                </label>
                <textarea
                  id="field-scan-go-allowed-notes"
                  className="w-full min-h-[88px] px-3 py-2 rounded-lg bg-surface-container-high text-on-surface text-sm border-none outline-none focus:ring-2 focus:ring-primary/20 resize-y"
                  placeholder={
                    isAllowedReleaseNotesRequired
                      ? "Document why these devices are being restricted..."
                      : "Optional notes to apply to selected devices..."
                  }
                  value={allowedReleaseNotes}
                  onChange={(e) => setAllowedReleaseNotes(e.target.value)}
                  disabled={isSendingCommand}
                  aria-required={isAllowedReleaseNotesRequired}
                />
                <p className="text-[11px] text-on-surface-variant">
                  {isAllowedReleaseNotesRequired
                    ? "Required when setting Allowed to False. Sent with the command and saved for all selected devices before the status change."
                    : "Optional when re-enabling devices. If provided, notes are saved before the status change."}
                </p>
                {isAllowedReleaseNotesRequired && !String(allowedReleaseNotes || "").trim() && (
                  <p className="text-xs text-error">Enter a note before restricting device usage.</p>
                )}
              </div>
            </div>
          )}
          {isFieldScanAndGoReleaseWallCommand && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
              <div className="space-y-1">
                <p className="text-xs font-semibold text-on-surface">Walls (this branch)</p>
                <p className="text-[11px] text-on-surface-variant">
                  Mark each wall to include in <span className="font-mono">wall_id</span> for this branch.
                </p>
              </div>
              {scanAndGoWallOptions.length === 0 ? (
                <p className="text-[11px] text-on-surface-variant">
                  No wall_id values found in this branch device cache.
                </p>
              ) : (
                <ul className="max-h-48 overflow-y-auto rounded-md border border-outline-variant/20 divide-y divide-outline-variant/10">
                  {scanAndGoWallOptions.map((option) => (
                    <li key={option.value} className="px-2 py-2">
                      <label className="flex items-center gap-2 cursor-pointer text-xs text-on-surface">
                        <input
                          type="checkbox"
                          className="rounded border-outline-variant text-primary focus:ring-primary/20 h-4 w-4 shrink-0"
                          checked={selectedScanAndGoWallIds.includes(option.value)}
                          onChange={() => toggleScanAndGoWallSelection(option.value)}
                          disabled={isSendingCommand}
                        />
                        <span className="font-mono break-all">{option.label}</span>
                      </label>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
          {commandScope === "field" && fieldCommandResponse && !isFieldMultiFetchLocationLogCommand && !isFieldTriggerCameraCommand && !isFieldTriggerScreenshotCommand && !isFieldFetchNcrStatusCommand && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-2">
              <p className="text-xs font-semibold text-on-surface">Field Response</p>
              <pre className="text-[11px] text-on-surface-variant bg-surface-container-high rounded-lg p-3 overflow-x-auto">
                {JSON.stringify(fieldCommandResponse, null, 2)}
              </pre>
            </div>
          )}
          {isFieldMultiFetchLocationLogCommand && locationVersionFetchedDeviceIds.length > 0 && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-2">
              <p className="text-xs font-semibold text-on-surface">Location / Version Results</p>
              <p className="text-[11px] text-on-surface-variant">
                View location and app version data for {locationVersionFetchedDeviceIds.length}{" "}
                device(s) on the branch map.
              </p>
              <button
                type="button"
                className="w-full px-4 py-2 bg-primary text-white font-semibold text-xs rounded-lg hover:opacity-90 transition-opacity flex items-center justify-center"
                onClick={() => onShowLocationVersionWindow?.()}
                disabled={isSendingCommand}
              >
                <span className="material-symbols-outlined text-sm mr-2">location_on</span>
                Show Location / Version
              </button>
            </div>
          )}
          {isFieldMultiSwanSongCommand && triggeredSwanSongDeviceIds.length > 0 && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-2">
              <p className="text-xs font-semibold text-on-surface">Swan Song Results</p>
              <p className="text-[11px] text-on-surface-variant">
                Open a results tab for each of the {triggeredSwanSongDeviceIds.length} triggered device(s).
              </p>
              <button
                type="button"
                className="w-full px-4 py-2 bg-primary text-white font-semibold text-xs rounded-lg hover:opacity-90 transition-opacity flex items-center justify-center"
                onClick={() => onShowSwanSongResults?.()}
                disabled={isSendingCommand}
              >
                <span className="material-symbols-outlined text-sm mr-2">open_in_new</span>
                Show SS Results
              </button>
            </div>
          )}
          {isFieldTriggerCameraCommand && triggeredCameraDevices.length > 0 && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-2">
              <p className="text-xs font-semibold text-on-surface">Camera Results</p>
              <p className="text-[11px] text-on-surface-variant">
                Open a results tab for each of the {triggeredCameraDevices.length} triggered device(s).
              </p>
              <button
                type="button"
                className="w-full px-4 py-2 bg-primary text-white font-semibold text-xs rounded-lg hover:opacity-90 transition-opacity flex items-center justify-center"
                onClick={() => onShowCameraResults?.()}
                disabled={isSendingCommand}
              >
                <span className="material-symbols-outlined text-sm mr-2">photo_camera</span>
                Show Camera Results
              </button>
            </div>
          )}
          {isFieldTriggerScreenshotCommand && triggeredScreenshotDevices.length > 0 && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
              <p className="text-xs font-semibold text-on-surface">Screenshot Results</p>
              <p className="text-[11px] text-on-surface-variant">
                Screenshots for {triggeredScreenshotDevices.length} triggered device(s).
              </p>
              <div className="space-y-4 max-h-80 overflow-y-auto">
                {triggeredScreenshotDevices.map((device) => (
                  <div key={device.deviceId || device.serialNumber} className="space-y-2">
                    <p className="text-xs font-semibold font-mono text-on-surface break-all">
                      {device.serialNumber || device.deviceId}
                    </p>
                    {Array.isArray(device.screenshots) && device.screenshots.length > 0 ? (
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {device.screenshots.map((shot) => (
                          <div key={`${device.deviceId}-${shot.ts}`} className="space-y-1">
                            <a href={shot.url} target="_blank" rel="noreferrer">
                              <img
                                src={shot.url}
                                alt={`Screenshot for ${device.serialNumber || device.deviceId}`}
                                className="w-full rounded-lg border border-outline-variant/20"
                              />
                            </a>
                            {shot.ts && (
                              <p className="text-[10px] text-on-surface-variant">
                                {new Date(shot.ts).toLocaleString()}
                              </p>
                            )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-[11px] text-on-surface-variant">No screenshots returned yet.</p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
          {getTextPayloadKeyForEndpoint(commandEndpoint, textCommandOptions) && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-2">
              <label className="text-xs font-semibold text-on-surface" htmlFor="mdm-command-text">
                Text
              </label>
              <textarea
                id="mdm-command-text"
                className="w-full min-h-[88px] px-3 py-2 rounded-lg bg-surface-container-high text-on-surface text-sm border-none outline-none focus:ring-2 focus:ring-primary/20 resize-y"
                placeholder="Text to send with this command…"
                value={commandMessageText}
                onChange={(e) => setCommandMessageText(e.target.value)}
                disabled={isSendingCommand}
              />
            </div>
          )}
          <div className="bg-surface-container-low p-4 rounded-xl space-y-3">
            <div className="flex items-start space-x-3">
              <span className="material-symbols-outlined text-primary text-xl">info</span>
              <p className="text-xs text-on-surface-variant leading-relaxed">
                This action will be broadcast to{" "}
                <span className="font-bold text-on-surface">
                  {parsedPayloadDeviceCount} {commandBroadcastTargetLabel}
                </span>{" "}
                immediately.
              </p>
            </div>
            {!isFieldScanAndGoReleaseWallCommand && (
              <div className="space-y-2 pl-9">
                <p className="text-xs font-semibold text-on-surface">Devices in this operation</p>
                {commandTargetDevices.length > 0 ? (
                  <ul className="max-h-48 overflow-y-auto rounded-md border border-outline-variant/20 divide-y divide-outline-variant/10 bg-surface-container-high/40">
                    {commandTargetDevices.map((device) => (
                      <li key={device.deviceId} className="px-3 py-2">
                        <p className="text-xs font-semibold font-mono text-on-surface break-all">
                          {device.deviceId}
                        </p>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-[11px] text-on-surface-variant">No devices selected.</p>
                )}
              </div>
            )}
          </div>
          {(isSendingCommand || commandProgress.status !== "idle") && (
            <div className="bg-surface-container-low p-4 rounded-xl space-y-2">
              <div className="flex items-center justify-between text-xs font-semibold text-on-surface">
                <span>Command progress</span>
                <span>
                  {progressDone}/{progressTotal}
                </span>
              </div>
              <div className="w-full h-2 rounded-full bg-surface-container-high overflow-hidden">
                <div
                  className="h-full bg-primary transition-all duration-300"
                  style={{ width: `${progressPercent}%` }}
                ></div>
              </div>
              <p className="text-[11px] text-on-surface-variant">
                {commandProgress.success} success, {commandProgress.failed} failed
                {commandProgress.status === "completed" && commandUpdatedDevices > 0
                  ? ` - updated ${commandUpdatedDevices} devices`
                  : ""}
              </p>
              <div className="space-y-2 pt-1">
                <button
                  type="button"
                  className="w-full flex items-center justify-between px-2 py-1 rounded-md bg-surface-container-high hover:bg-surface-container-highest transition-colors text-[11px] font-semibold text-on-surface"
                  onClick={() => setShowSuccessfulDeviceIds((prev) => !prev)}
                >
                  <span>Successful device_ids ({commandSuccessfulDeviceIds.length})</span>
                  <span className="text-sm leading-none">{showSuccessfulDeviceIds ? "-" : "+"}</span>
                </button>
                {showSuccessfulDeviceIds && (
                  <div className="max-h-32 overflow-y-auto rounded-md bg-surface-container-high px-2 py-1">
                    {commandSuccessfulDeviceIds.length > 0 ? (
                      <ul className="space-y-1">
                        {commandSuccessfulDeviceIds.map((deviceId) => (
                          <li key={`success-${deviceId}`} className="text-[11px] font-mono text-on-surface">
                            {deviceId}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-[11px] text-on-surface-variant">No successful device_ids yet.</p>
                    )}
                  </div>
                )}
                <button
                  type="button"
                  className="w-full flex items-center justify-between px-2 py-1 rounded-md bg-surface-container-high hover:bg-surface-container-highest transition-colors text-[11px] font-semibold text-on-surface"
                  onClick={() => setShowFailedDeviceIds((prev) => !prev)}
                >
                  <span>Failed device_ids ({commandFailedDeviceIds.length})</span>
                  <span className="text-sm leading-none">{showFailedDeviceIds ? "-" : "+"}</span>
                </button>
                {showFailedDeviceIds && (
                  <div className="max-h-32 overflow-y-auto rounded-md bg-surface-container-high px-2 py-1">
                    {commandFailedDeviceIds.length > 0 ? (
                      <ul className="space-y-1">
                        {commandFailedDeviceIds.map((deviceId) => (
                          <li key={`failed-${deviceId}`} className="text-[11px] font-mono text-error">
                            {deviceId}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-[11px] text-on-surface-variant">No failed device_ids yet.</p>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          {commandError && (
            <div className="bg-error-container text-on-error-container p-3 rounded-lg text-xs font-semibold">
              {commandError}
            </div>
          )}
        </div>
        <CommandModalActions
          isSendingCommand={isSendingCommand}
          isExecuteDisabled={isExecuteDisabled}
          onCancel={onClose}
          onExecute={onExecute}
        />
      </div>
    </div>
  );
};

export default MdmCommandModal;
